export * as ReportUrls from './report-urls';

export const createShareUrl = (meetingId: string) => {
  const domain = window.location.origin;
  return `${domain}/shared_report/${meetingId}`;
};
